import { BLUE, GREEN, PLUM, RED, TOMATO_RED, GREY_300, GOLD } from '@propertypal/shared/src/styles/theme';
import { PINK } from '@propertypal/shared/src/styles/theme/propertynews';
import platform from '@propertypal/shared/src/utils/platform';
import styled from 'styled-components';

const COLOR_MAP: { [key: string]: string } = {
  comingSoon: PLUM,
  newPhase: GREEN,
  newPhaseComingSoon: GREEN,
  futureDevelopment: BLUE,
  lastRemainingProperty: RED,
  lastFew: RED,
  premier: platform.select(TOMATO_RED, PINK),
  status: platform.select(TOMATO_RED, PINK),
  pinned: GOLD,
};

export const Container = styled.div<{ $type: string }>`
  background-color: ${(props) => (COLOR_MAP[props.$type] ? COLOR_MAP[props.$type] : GREY_300)};
  width: 160px;
  height: 32px;
  padding: 0 25px 0 20px;
  justify-content: center;
  transform: rotate(-45deg) translate(-44px, -6px);
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  z-index: 2;

  @media print {
    display: none;
  }
`;

export const BannerText = styled.p<{ $color?: string }>`
  color: ${(props) => props.$color || props.theme.white};
  text-align: center;
  font-weight: bold;
  font-size: 14px;
  line-height: 12px;
`;
